import type { Logger } from "@expert/logging";
import { DraggableComponent } from "../../drag";
import { useOzmoStore } from "../store";
import classes from "./OzmoFrame.module.css";

interface OzmoFrameProps {
    logger: Logger;
    opened: boolean;
    onClose: () => void;
}

export function OzmoFrame({ logger, opened, onClose }: OzmoFrameProps) {
    const { ozmoFrameUrl, ozmoFrameLocation, setOzmoFrameLocation, ozmoFrameSize, setOzmoFrameSize } = useOzmoStore();

    return (
        <DraggableComponent
            backgroundColor={`var(--mantine-color-dark-5)`}
            iconColor={`var(--mantine-color-dark-0)`}
            location={ozmoFrameLocation}
            logger={logger}
            onClose={onClose}
            opened={opened}
            setLocation={setOzmoFrameLocation}
            setSize={setOzmoFrameSize}
            size={ozmoFrameSize}
            testId="ozmo"
            title="Ozmo"
        >
            <iframe
                className={classes.iFrame}
                height="100%"
                width="100%"
                src={ozmoFrameUrl}
                sandbox="allow-scripts allow-forms allow-same-origin"
                title="ozmo-iframe"
            />
        </DraggableComponent>
    );
}
